module.exports = {
  ConfigureDisplayColumns: '配置显示列',
  AllNames: '所有名',
  SelectedColumns: '已选列',
  YouToViewSecondaryInformation: '你没有权限查看二级表信息！',
  Yes: '是',
  WorkflowNumber: '工作号',
  YouToSetSecondaryColumns: '你没有权限设置二级表显示列！',
  CancelCounting: '取消计数'
}
